import Script from "next/script";
import React  from "react";

const LoadPaytmScript = () => {

	const endpoint   = process.env.APP_ENV === "prod" ? "securegw.paytm.in" : "securegw-stage.paytm.in";
	const merchantID = process.env.APP_ENV === "prod" ? process.env.PAYTM_MERCHANT_ID : process.env.PAYTM_MERCHANT_ID_DEV;

	return (
		<Script
			crossOrigin = "anonymous"
			src         = { `https://${ endpoint }/merchantpgpui/checkoutjs/merchants/${ merchantID }.js` }
			type        = "application/javascript"
		/>
	);
};

export default LoadPaytmScript;

